"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Discount_service_1 = __importDefault(require("@CommonFrontendBackend/Discount/Discount.service"));
var inversify_1 = require("inversify");
var BillingScheduleOrchestrator_1 = require("QuoteV2/BillingSchedule/BillingScheduleOrchestrator");
var CalculateItem_1 = require("./CalculateItem");
var CalculateQuote_1 = require("./CalculateQuote");
var CalculateSection_1 = require("./CalculateSection");
var TaxService_1 = __importDefault(require("QuoteV2/TaxService"));
var CalculatorService = (function () {
    function CalculatorService(taxService, variableService, discountService, billingScheduleOrchestrator) {
        this.taxService = taxService;
        this.variableService = variableService;
        this.discountService = discountService;
        this.billingScheduleOrchestrator = billingScheduleOrchestrator;
    }
    CalculatorService.prototype.calculateQuote = function (quoteModel) {
        return (0, CalculateQuote_1.calculateQuote)(quoteModel, this.taxService, this.variableService, this.discountService, this.billingScheduleOrchestrator, false);
    };
    CalculatorService.prototype.calculateSection = function (sectionModel, currency) {
        return (0, CalculateSection_1.calculateSection)(sectionModel, this.variableService, this.discountService, this.billingScheduleOrchestrator, currency, false);
    };
    CalculatorService.prototype.calculateItem = function (itemModel, currency) {
        return (0, CalculateItem_1.calculateItem)(itemModel, this.variableService, this.discountService, this.billingScheduleOrchestrator, currency, false);
    };
    var _a, _b, _c;
    CalculatorService = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)(TaxService_1.default)),
        __param(1, (0, inversify_1.inject)("variableService")),
        __param(2, (0, inversify_1.inject)("discountService")),
        __param(3, (0, inversify_1.inject)("billingScheduleOrchestrator")),
        __metadata("design:paramtypes", [typeof (_a = typeof TaxService_1.default !== "undefined" && TaxService_1.default) === "function" ? _a : Object, Object, typeof (_b = typeof Discount_service_1.default !== "undefined" && Discount_service_1.default) === "function" ? _b : Object, typeof (_c = typeof BillingScheduleOrchestrator_1.BillingScheduleOrchestrator !== "undefined" && BillingScheduleOrchestrator_1.BillingScheduleOrchestrator) === "function" ? _c : Object])
    ], CalculatorService);
    return CalculatorService;
}());
exports.default = CalculatorService;
